import { Text, TextProps, Tooltip } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'

interface iTextoTruncadoProps extends TextProps {
  texto?: string
  linhas?: number
}

// Tooltip so aparece quando o texto realmente nao coube: balao em texto inteiro so atrapalha
export const TextoTruncado: React.FC<iTextoTruncadoProps> = ({ texto, linhas = 2, ...rest }) => {
  const referencia = useRef<HTMLParagraphElement>(null)
  const [truncado, setTruncado] = useState(false)

  useEffect(() => {
    function verificar (): void {
      const elemento = referencia.current

      if (elemento === null) return

      setTruncado(
        elemento.scrollHeight > elemento.clientHeight + 1 ||
        elemento.scrollWidth > elemento.clientWidth + 1
      )
    }

    verificar()

    window.addEventListener('resize', verificar)

    return () => window.removeEventListener('resize', verificar)
  }, [texto, linhas])

  return (
    <Tooltip
      label={texto}
      isDisabled={!truncado}
      placement={'top-start'}
      hasArrow
      bg={'var(--Gray1)'}
      color={'white'}
      borderRadius={'.25rem'}
      fontSize={'.8125rem'}
      p={'.625rem'}
      maxW={'32rem'}
      whiteSpace={'pre-wrap'}
    >
      <Text ref={referencia} noOfLines={linhas} {...rest}>
        {texto}
      </Text>
    </Tooltip>
  )
}
